import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "alert-input-consecutive" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "default-value"
}

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertInputCurrent',
  props: {
    threshold: {},
    defaultValueString: { default: undefined }
  },
  emits: ['update:threshold'],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const computedThreshold = computed(() => props.threshold ?? '1.0');

return (_ctx: any,_cache: any) => {
  const _component_I18nT = _resolveComponent("I18nT")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('shortage_forecast_current_high')), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_I18nT, {
        keypath: "dashboard:アラート条件:内示に対して当月の出荷済み数量がn%を超える",
        tag: "span",
        class: "alert-input-consecutive__condition"
      }, {
        n: _withCtx(() => [
          _createElementVNode("input", {
            value: computedThreshold.value,
            type: "number",
            min: "0",
            max: "999",
            class: "alert-input-consecutive__input alert-input-consecutive__input--percentage",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:threshold', $event))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["e"]))
          }, null, 40, _hoisted_3)
        ]),
        _: 1
      })
    ]),
    (_ctx.defaultValueString)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.defaultValueString), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})